import React, { useState } from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Stats from "@/components/landing/Stats";
import About from "@/components/landing/About";
import Services from "@/components/landing/Services";
import Process from "@/components/landing/Process";
import Industries from "@/components/landing/Industries";
import Certifications from "@/components/landing/Certifications";
import TechStack from "@/components/landing/TechStack";
import CaseStudies from "@/components/landing/CaseStudies";
import Pricing from "@/components/landing/Pricing";
import Configurator from "@/components/landing/Configurator";
import Testimonials from "@/components/landing/Testimonials";
import FAQ from "@/components/landing/FAQ";
import FinalCta from "@/components/landing/FinalCta";
import Footer from "@/components/landing/Footer";
import BookingDialog from "@/components/landing/BookingDialog";
import CheckoutDialog from "@/components/landing/CheckoutDialog";

const Landing = () => {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const [selectedPkg, setSelectedPkg] = useState(null);

  const handleBook = () => setBookingOpen(true);
  const handlePackages = () => {
    const el = document.getElementById("pricing");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const handleSelectPackage = (pkg) => {
    setSelectedPkg(pkg);
    setCheckoutOpen(true);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header onBookClick={handleBook} />
      <main>
        <Hero onBookClick={handleBook} onPackagesClick={handlePackages} />
        <Stats />
        <About />
        <Services />
        <Process />
        <Industries />
        <Certifications />
        <TechStack />
        <CaseStudies onRequestDetails={handleBook} />
        <Pricing onSelectPackage={handleSelectPackage} />
        <Configurator />
        <Testimonials />
        <FAQ />
        <FinalCta onBookClick={handleBook} />
      </main>
      <Footer />

      <BookingDialog open={bookingOpen} onOpenChange={setBookingOpen} />
      <CheckoutDialog open={checkoutOpen} onOpenChange={setCheckoutOpen} pkg={selectedPkg} />
    </div>
  );
};

export default Landing;
